var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopOval4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1029,
    height: 956,
    viewBox: "0 0 1029 956",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_162_7578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.065 325.656C714.254 351.624 728.336 487.562 628.993 568.623C529.649 649.685 354.499 645.174 333.31 619.206C312.121 593.238 305.674 539.622 405.018 458.561C500.58 373.155 671.876 299.688 693.065 325.656Z",
    fill: "url(#paint0_linear_162_7578)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_162_7578",
    x: 0.38147,
    y: 0.355957,
    width: 1027.93,
    height: 955.643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 160,
    result: "effect1_foregroundBlur_162_7578"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_162_7578",
    x1: 446.931,
    y1: 474.147,
    x2: 626.399,
    y2: 535.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10477D",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552788,
    stopColor: "#89D213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA658F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopOval4);
export default __webpack_public_path__ + "static/media/desktop-oval-4.57cc1b8536f6cfba4d06100fa243fff2.svg";
export { ForwardRef as ReactComponent };